"use client";

import { FC } from "react";
import { TbLassoPolygon } from "react-icons/tb";

import { useStyles } from "./styles";
import { Nullable } from "@/types/common";
import { TransformationType } from "@/types/thread";
import { useGenContext } from "@/context/GenContext";
import Image from "@/components/common/Image";

interface SourceImagesProps {
  rawImageUrl: Nullable<string>;
  isSubscribed: boolean;
  inspirationImages?: string[];
  modelUsed?: TransformationType;
}

const SourceImages: FC<SourceImagesProps> = ({
  rawImageUrl,
  isSubscribed,
  inspirationImages = [],
  modelUsed,
}) => {
  const { classes } = useStyles({ isSubscribed });
  const { addImage } = useGenContext();

  const displayedInspirationImages = [...inspirationImages];
  if (rawImageUrl) {
    displayedInspirationImages.unshift(rawImageUrl);
  }

  const handleImageClick = (imageUrl: string) => {
    if (!isSubscribed) return;
    addImage(imageUrl);
  };

  if (!rawImageUrl && inspirationImages.length === 0) return null;

  return (
    <div className={classes.container}>
      <div className={classes.inspirationImages}>
        {displayedInspirationImages.map((image, i) => (
          <div
            key={`inspiration-preview-${i + 1}`}
            className={classes.inspirationImageContainer}
            onClick={() => handleImageClick(image)}
          >
            <Image
              width={84}
              height={84}
              src={image}
              alt={`Inspiration Image ${i + 1}`}
              className={classes.inspirationImage}
            />
            {modelUsed === TransformationType.InPaint && (
              <TbLassoPolygon className={classes.inPaintIndicator} />
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default SourceImages;
